import React from 'react'

const BannerHome2021 = ({ menu }) => {
  if (!menu?.description) return null

  return (
    <section className="banner-home2021">
      <div className="w-container-small">
        <div
          className="banner-home2021__content"
          dangerouslySetInnerHTML={{ __html: menu.description }}
        />
      </div>
    </section>
  )
}

export default BannerHome2021
